/**
 * Find words with *
 * console.log(filterMatches('***ing', ['loving', 'mating', 'cats', 'wording']));
 * @param {string} needle
 * @param {string[]} haystack
 * @returns {string[]} array of answers
 */
function FilterMatches(needle, haystack) {
    const regex = new RegExp('^' + needle.replace(/\*/g, '.') + '$');
    return haystack.filter((word) => regex.test(word));
}

/**
 * Get the correct database URL based on the node environment
 * @returns { String }
 */
function GetDbUrl() {
    return `${CONFIG_DB.url}${CONFIG_APP.env}`;
}

const MSG = Object.freeze({
    temp: 'temp',
    signIn: 'sign-in',
    signOut: 'sign-out',
    requestToken: 'request-token',
    validateToken: 'validate-token',
    validateSlug: 'validate-slug',
    validateUsername: 'validate-username',
    changePassword: 'change-password',
    getVersion: 'get-version',
    log: Object.freeze({
        debug: 'log-debug',
        error: 'log-error',
        info: 'log-info',
        set: Object.freeze({
            debug: Object.freeze({
                disable: 'log-set-debug-disable',
                enable: 'log-set-debug-enable'
            }),
            trace: Object.freeze({
                disable: 'log-set-trace-disable',
                enable: 'log-set-trace-enable'
            }),
            writeToConsole: Object.freeze({
                disable: 'log-set-write-to-console-disable',
                enable: 'log-set-write-to-console-enable'
            })
        }),
        trace: 'log-trace',
        warn: 'log-warn'
    }),
    count: Object.freeze({
        parentsAddedBy: 'count-parents-added-by',
        all: 'count-all'
    }),
    create: Object.freeze({
        list: 'create-list',
        employee: 'create-employee',
        parent: 'create-parent',
        program: 'create-program',
        service: Object.freeze({
            individual: 'create-service-individual',
            group: 'create-service-group',
            program: 'create-service-program'
        })
    }),
    read: Object.freeze({
        employees: 'read-employees',
        lists: 'read-lists',
        parents: 'read-parents',
        programs: 'read-programs',
        services: Object.freeze({
            individual: 'read-services-individual',
            group: 'read-services-group',
            program: 'read-services-program'
        }),
        children: Object.freeze({
            byParent: 'read-children-by-parent'
        })
    }),
    readOne: Object.freeze({
        parent: 'read-one-parent'
    }),
    report: Object.freeze({
        children: Object.freeze({
            activeOverAge12: 'report-children-active-over-age-12',
            inactive: 'report-children-inactive'
        }),
        parents: Object.freeze({
            noEmail: 'report-parents-no-email',
            zero1: 'report-parents-01',
            zero2: 'report-parents-02'
        }),
        state: Object.freeze({
            one: 'report-state-1',
            two: 'report-state-2',
            three: 'report-state-3',
            four: 'report-state-4',
            five: 'report-state-5',
            six: 'report-state-6',
            seven: 'report-state-7',
            eight: 'report-state-8',
            nine: 'report-state-9',
            ten: 'report-state-10',
            eleven: 'report-state-11',
            twelve: 'report-state-12',
            thirteen: 'report-state-13',
            fourteen: 'report-state-14'
        })
    }),
    search: Object.freeze({
        parents: 'search-parents',
        programs: 'search-programs'
    }),
    update: Object.freeze({
        list: 'update-list',
        employee: 'update-employee',
        parent: 'update-parent',
        program: 'update-program',
        service: Object.freeze({
            individual: 'update-service-individual',
            group: 'update-service-group',
            program: 'update-service-program'
        })
    })
});

const NAME = Object.freeze({
    app: Object.freeze({
        token: 'cfceToken',
        events: 'cfceEvents',
        secret: '6282a821-ba27-4bd1-bb37-0cca5b0b33f6'
    }),
    db: Object.freeze({
        collection: Object.freeze({
            app: 'app',
            employees: 'employees',
            children: 'children',
            lists: 'lists',
            parents: 'parents',
            programs: 'programs',
            servicesIndividual: 'servicesIndividual',
            servicesGroup: 'servicesGroup',
            servicesProgram: 'servicesProgram'
        }),
        model: Object.freeze({
            app: 'App',
            employee: 'Employee',
            child: 'Child',
            list: 'List',
            parent: 'Parent',
            program: 'Program',
            serviceIndividual: 'ServiceIndividual',
            serviceGroup: 'ServiceGroup',
            serviceProgram: 'ServiceProgram'
        })
    }),
    personType: Object.freeze({
        employee: 'EMPLOYEE',
        parent: 'PARENT',
        child: 'CHILD',
        contact: 'CONTACT'
    }),
    listType: Object.freeze({
        gender: 'GENDER',
        state: 'STATE',
        language: 'LANGUAGE',
        relationship: 'RELATIONSHIP',
        programType: 'PROGRAM_TYPE',
        serviceTypeIndividual: 'SERVICE_TYPE_INDIVIDUAL',
        serviceTypeJ2TC: 'SERVICE_TYPE_J2TC',
        serviceTypeGroup: 'SERVICE_TYPE_GROUP',
        serviceTypeProgram: 'SERVICE_TYPE_PROGRAM'
    })
});

const LIST_TYPES = Object.freeze([
    NAME.listType.gender,
    NAME.listType.state,
    NAME.listType.language,
    NAME.listType.relationship,
    NAME.listType.programType,
    NAME.listType.serviceTypeIndividual,
    NAME.listType.serviceTypeJ2TC,
    NAME.listType.serviceTypeGroup,
    NAME.listType.serviceTypeProgram
]);

/**
 * @type { { env: String } }
 */
const CONFIG_APP = Object.freeze({
    env: process.env.NODE_ENV !== 'production' ? 'dev' : 'prod'
});

/**
 * @type { { url: String, options: { family: Number }, schemaOptions: { timestamps: Boolean, optimisticConcurrency: Boolean } } }
 */
const CONFIG_DB = Object.freeze({
    url: 'mongodb+srv://cfce_db_admin:PxjP2X1DKVSUSPyS@clustercfceonline.ouvqx.mongodb.net/',
    options: Object.freeze({ family: 4 }),
    schemaOptions: Object.freeze({
        timestamps: true,
        optimisticConcurrency: true
    })
});

const validEmailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

/**
 * Validate Email
 * @param { String } email
 * @returns { Boolead }
 */
function ValidateEmail(email) {
    return email.match(validEmailRegex);
}

function GetEditorFormats() {
    return (
        <span className="ql-formats">
            <button className="ql-bold" type="button">
                <svg viewBox="0 0 18 18">
                    {' '}
                    <path
                        className="ql-stroke"
                        d="M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z"
                    ></path>{' '}
                    <path
                        className="ql-stroke"
                        d="M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z"
                    ></path>{' '}
                </svg>
            </button>

            <button className="ql-italic" type="button">
                <svg viewBox="0 0 18 18">
                    {' '}
                    <line className="ql-stroke" x1="7" x2="13" y1="4" y2="4"></line>{' '}
                    <line className="ql-stroke" x1="5" x2="11" y1="14" y2="14"></line>{' '}
                    <line className="ql-stroke" x1="8" x2="10" y1="14" y2="4"></line>{' '}
                </svg>
            </button>

            <button className="ql-underline" type="button">
                <svg viewBox="0 0 18 18">
                    {' '}
                    <path
                        className="ql-stroke"
                        d="M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3"
                    ></path>{' '}
                    <rect
                        className="ql-fill"
                        height="1"
                        rx="0.5"
                        ry="0.5"
                        width="12"
                        x="3"
                        y="15"
                    ></rect>{' '}
                </svg>
            </button>

            <button className="ql-list" value="ordered" type="button">
                <svg viewBox="0 0 18 18">
                    {' '}
                    <line className="ql-stroke" x1="7" x2="15" y1="4" y2="4"></line>{' '}
                    <line className="ql-stroke" x1="7" x2="15" y1="9" y2="9"></line>{' '}
                    <line className="ql-stroke" x1="7" x2="15" y1="14" y2="14"></line>{' '}
                    <line className="ql-stroke ql-thin" x1="2.5" x2="4.5" y1="5.5" y2="5.5"></line>{' '}
                    <path
                        className="ql-fill"
                        d="M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z"
                    ></path>{' '}
                    <path
                        className="ql-stroke ql-thin"
                        d="M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156"
                    ></path>{' '}
                    <path
                        className="ql-stroke ql-thin"
                        d="M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109"
                    ></path>{' '}
                </svg>
            </button>

            <button className="ql-list" value="bullet" type="button">
                <svg viewBox="0 0 18 18">
                    {' '}
                    <line className="ql-stroke" x1="6" x2="15" y1="4" y2="4"></line>{' '}
                    <line className="ql-stroke" x1="6" x2="15" y1="9" y2="9"></line>{' '}
                    <line className="ql-stroke" x1="6" x2="15" y1="14" y2="14"></line>{' '}
                    <line className="ql-stroke" x1="3" x2="3" y1="4" y2="4"></line>{' '}
                    <line className="ql-stroke" x1="3" x2="3" y1="9" y2="9"></line>{' '}
                    <line className="ql-stroke" x1="3" x2="3" y1="14" y2="14"></line>{' '}
                </svg>
            </button>
        </span>
    );
}

function PLeft({ filteredRecordCount, recordCount, skip, limit }) {
    const totalRecords = filteredRecordCount > 0 ? filteredRecordCount : recordCount;
    const start = skip + 1;

    let end = skip + limit;

    if (skip > 0) {
        end = end > totalRecords ? totalRecords : end;
    }

    if (end > totalRecords) {
        return (
            <>
                <span>
                    {start}-{totalRecords} of {totalRecords}
                    {filteredRecordCount > 0 ? ' Filtered' : ''}
                </span>
            </>
        );
    }

    return (
        <>
            <span>
                {start}-{end} of {totalRecords}
                {filteredRecordCount > 0 ? ' Filtered' : ''}
            </span>
        </>
    );
}

export {
    CONFIG_APP,
    CONFIG_DB,
    FilterMatches,
    GetDbUrl,
    GetEditorFormats,
    LIST_TYPES,
    MSG,
    NAME,
    PLeft,
    ValidateEmail
};
